import React from "react";
import { connect } from "react-redux";
import PageTitle from "sc/ui/sites/oncall/components/PageTitle";
import {
  shiftsDefinitionsPageLoad,
  requestCreateShiftDefinition,
  requestDeleteShiftDefinition,
  requestUpdateShiftDefinition,
  requestMoveShiftDefinition,
} from "../../actions/shifts-definitions";
import {
  isLoadingShiftsDefinitions,
  shiftsDefinitions,
  regionEngineers,
  shiftsDefinitionsError,
} from "../../selectors/shifts-definitions";
import Calendar from "../../components/calendar/EditableCalendar";
import { region } from "../../selectors/regions";
import { push } from "react-router-redux/actions";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";
import PageNotFound from "sc/ui/sites/oncall/pages/PageNotFound";
import { selected } from "../../selectors/shifts-definitions";
import { shiftDefinitionClicked } from "../../actions/shifts-definitions";

const ConnectedCalendar = connect(
  (state, ownProps) => ({
    selected: selected(state),
    shiftsDefinitions: shiftsDefinitions(state),
    engineers: regionEngineers(state, ownProps.regionId),
    region: region(state),
    loading: isLoadingShiftsDefinitions(state),
    backendError: shiftsDefinitionsError(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(shiftsDefinitionsPageLoad(ownProps.regionId)),
    onSelect: shiftDefinition =>
      dispatch(shiftDefinitionClicked(shiftDefinition)),
    onNewShiftDefinition: shiftDefinition => {
      dispatch(
        requestCreateShiftDefinition(shiftDefinition, ownProps.regionId),
      );
    },
    onMoveShiftDefinition: oldShiftDefinition => newShiftDefinition =>
      dispatch(
        requestMoveShiftDefinition(
          oldShiftDefinition.id,
          newShiftDefinition.start,
        ),
      ),
    onUpdateShiftDefinition: oldShiftDefinition => newShiftDefinition =>
      dispatch(
        requestUpdateShiftDefinition(
          oldShiftDefinition.id,
          newShiftDefinition.start,
          newShiftDefinition.end,
          newShiftDefinition.priority,
        ),
      ),
    onDeleteShiftDefinition: shiftDefinition =>
      dispatch(requestDeleteShiftDefinition(shiftDefinition.id)),
    onRegionList: () => dispatch(push("/")),
  }),
)(
  componentWithLoadTrigger(
    class extends React.Component {
      constructor(props) {
        super(props);
        this.state = { uiError: "" };
      }

      componentWillReceiveProps(nextProps) {
        if (this.props.backendError !== nextProps.backendError) {
          this.setState({ uiError: nextProps.backendError });
        }
      }

      render = () => {
        if (this.props.loading) {
          return (
            <div id="1234">
              <PageTitle title="Loading Schedule..." />
            </div>
          );
        }
        return [
          <PageTitle key="title" title={this.props.region.name} />,
          <Calendar
            key="calendar"
            onDismissError={() => this.setState({ uiError: "" })}
            uiError={this.state.uiError}
            onRegionList={this.props.onRegionList}
            onNewShiftDefinition={this.props.onNewShiftDefinition}
            onMoveShiftDefinition={this.props.onMoveShiftDefinition}
            onUpdateShiftDefinition={this.props.onUpdateShiftDefinition}
            onDeleteShiftDefinition={this.props.onDeleteShiftDefinition}
            selected={this.props.selected}
            onSelect={this.props.onSelect}
            engineers={this.props.engineers}
            shiftsDefinitions={this.props.shiftsDefinitions}
            region={this.props.region}
          />,
        ];
      };
    },
  ),
);

export default ({ match }) =>
  isNaN(match.params.regionId) ? (
    <PageNotFound />
  ) : (
    <ConnectedCalendar regionId={parseInt(match.params.regionId, 10)} />
  );



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-admin/SchedulePage.js